<template>
    <ul :class="$style.cards">
        <li
            v-for="card in cardsWithPlaceHolders"
            :key="card?.hru"
        >
            <div
                v-if="!card"
                :class="$style.card"
            >
                <CardContainer
                    :src="undefined"
                    :class="$style.image_override"
                />
                <AnimatedPlaceholder :class="$style.title_placeholder" />
            </div>
            <BaseLink
                v-else
                :class="$style.card"
                :to="getLink(card.routeName || ROUTE_NAMES.GAME_PAGE, card.hru)"
            >
                <CardContainer
                    :src="card.preview"
                    :class="$style.image_override"
                >
                    <Icon
                        v-if="card.previewIcon"
                        :name="card.previewIcon"
                        :class="$style.preview_icon"
                    />
                </CardContainer>
                <Typography
                    type="label"
                    size="m"
                >
                    {{ card.title }}
                </Typography>
                <Icon
                    v-if="card.statusIcon"
                    :name="card.statusIcon"
                    :class="$style.icon"
                />
            </BaseLink>
        </li>
    </ul>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import AnimatedPlaceholder from '@/components_new/AnimatedPlaceholder.vue'
import BaseLink from '@/components_new/BaseLink.vue'
import CardContainer from '@/components_new/CardContainer.vue'
import { IconNameType } from '@/components_new/Icon'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { ROUTE_NAMES, ROUTE_NAMES_GAME_GROUPS } from '@/router/constants'

const props = defineProps<{
    cards?: {
        title: string
        hru: string
        routeName?: typeof ROUTE_NAMES.GAME_PAGE | ROUTE_NAMES_GAME_GROUPS
        statusIcon?: IconNameType
        preview?: string
        previewIcon?: IconNameType
    }[]
}>()

const cardsWithPlaceHolders = computed(() => {
    if (props.cards) {
        return props.cards
    }
    return Array<undefined>(3).fill(undefined)
})

function getLink(routeName: typeof ROUTE_NAMES.GAME_PAGE | ROUTE_NAMES_GAME_GROUPS, hru: string) {
    if (routeName === ROUTE_NAMES.GAME_PAGE) {
        return { name: routeName, params: { game: hru } }
    }
    return { name: routeName, params: { hru } }
}
</script>
<style module>
.cards {
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;
}

.card {
    display: flex;
    align-items: center;
    gap: 12px;
    box-sizing: border-box;
    background-color: inherit;
    color: var(--white);
}

.card:hover,
.card:focus,
.card:hover .icon,
.card:focus .icon {
    color: var(--purple-600);
}

.image_override {
    width: 84px;
    flex-shrink: 0;
}

.preview_icon {
    margin: auto;
    width: 32px;
    height: 32px;
    color: var(--purple-600);
}

.icon {
    width: 24px;
    height: 24px;
    color: var(--white-20);
    margin-left: auto;
    flex-shrink: 0;
}
.title_placeholder {
    height: 32px;
    width: 60%;
    border-radius: 16px;
}

@media (--desktop-small-plus) {
    .card:hover,
    .card:focus {
        background-color: #3a3a3f;
    }

    .card {
        padding: 4px 12px;
    }
}
</style>
